import { Box, Typography } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import React from 'react';
import { styles } from './ControlOptions.styles';
import { EShowHeaderFooter, IHeaderControls } from '@opengov/stories-shared/constants';
import { ISetupPdfMessages } from '../../../../../../types/setupPDFTypes';
import { ControlOptions } from './ControlOptions';

export const HeaderOptions = ({
  messages,
  headerControls,
  onHeaderControlsChange
}: {
  messages: ISetupPdfMessages;
  headerControls: IHeaderControls;
  onHeaderControlsChange: (value: IHeaderControls) => void;
}) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.headerInfo}>
        <InfoIcon sx={styles.infoIcon} />
        <Typography sx={styles.headerInfoText}>{messages.headerInfo}</Typography>
      </Box>
      <ControlOptions
        type="header"
        messages={messages}
        selectedOption={headerControls?.showHeaderOn || EShowHeaderFooter.All}
        handleOptionChange={(option) => {
          onHeaderControlsChange({ ...headerControls, showHeaderOn: option } as IHeaderControls);
        }}
      />
    </Box>
  );
};
